import conversations from './sidebarItems/conversations';
import contacts from './sidebarItems/contacts';
import reports from './sidebarItems/reports';
import finops from './sidebarItems/finops';
import campaigns from './sidebarItems/campaigns';
import support from './sidebarItems/support';
import settings from './sidebarItems/settings';
import notifications from './sidebarItems/notifications';
import primaryMenu from './sidebarItems/primaryMenu';

export const getSidebarItems = accountId => ({
  primaryMenu: primaryMenu(accountId),
  secondaryMenu: [
    conversations(accountId),
    contacts(accountId),
    reports(accountId),
    finops(accountId),
    campaigns(accountId),
    support(accountId),
    settings(accountId),
    notifications(accountId),
  ],
});
